import * as React from 'react'

const SvgRejectFilled = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    fill="none"
    viewBox="0 0 56 56"
    {...props}
  >
    <rect width="48" height="48" x="4" y="4" fill="#FEE4E2" rx="24"></rect>
    <path fill="#FEE4E2" d="M0 0H24V24H0z" transform="translate(16 16)"></path>
    <path
      stroke="#F04438"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M33 23L23 33m0-10l10 10"
    ></path>
    <rect
      width="48"
      height="48"
      x="4"
      y="4"
      stroke="#FEF3F2"
      strokeWidth="8"
      rx="24"
    ></rect>
  </svg>
)

export default SvgRejectFilled
